/**
 * Rewards API Endpoints
 * Framework-agnostic endpoint definitions for rewards module
 */

import { API_BASE_URL } from '../config';

/**
 * Reward Category API Endpoints
 */
export const REWARD_CATEGORY_ENDPOINTS = {
  list: `${API_BASE_URL}hubadmin/list-product-cats`,
  create: `${API_BASE_URL}hubadmin/add-product-cats`,
  update: `${API_BASE_URL}hubadmin/edit-product-cats`,
  delete: `${API_BASE_URL}hubadmin/delete-product-cats`,
} as const;

/**
 * Instant Voucher API Endpoints
 */
export const INSTANT_VOUCHER_ENDPOINTS = {
  listProducts: `${API_BASE_URL}rewards/list-instant-product`,
  upload: `${API_BASE_URL}rewards/instant-voucher-upload`,
} as const;

/**
 * Reward Product API Endpoints
 */
export const REWARD_PRODUCT_ENDPOINTS = {
  list: `${API_BASE_URL}hubadmin/list-product`,
  edit: `${API_BASE_URL}hubadmin/edit-product`,
  uploadBulk: `${API_BASE_URL}hubadmin/product-excel-upload`,
  toggleStatus: `${API_BASE_URL}hubadmin/active-deactive`,
  getCategories: `${API_BASE_URL}hubadmin/list-product-cats`,
} as const;

/**
 * All Rewards Endpoints
 */
export const REWARDS_ENDPOINTS = {
  rewardCategory: REWARD_CATEGORY_ENDPOINTS,
  instantVoucher: INSTANT_VOUCHER_ENDPOINTS,
  rewardProduct: REWARD_PRODUCT_ENDPOINTS,
} as const;
